import React from "react";
import { View, Pressable } from "react-native";
import { Text } from "../Text";
import { orderFieldStyles as styles } from "./styles";

interface OrderFieldProps {
  label: string;
  value: string;
  prefix?: string;
  isActive: boolean;
  onPress: () => void;
  testID?: string;
}

const OrderField: React.FC<OrderFieldProps> = ({
  label,
  value,
  prefix,
  isActive,
  onPress,
  testID,
}) => (
  <View style={styles.container}>
    <Text style={styles.label}>
      <Text style={styles.required}>* </Text>
      {label}
    </Text>
    <Pressable
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel={label}
      accessibilityState={{ selected: isActive }}
      onPress={onPress}
      style={styles.inputRow}
    >
      {prefix && (
        <View style={styles.prefix}>
          <Text style={styles.prefixText}>{prefix}</Text>
        </View>
      )}
      <View style={[styles.input, isActive && styles.activeInput]}>
        <Text style={styles.valueText}>{value}</Text>
      </View>
    </Pressable>
  </View>
);

export default OrderField;
